import React from "react";
import Header from "./customer/Header";
import HomeHeader from "./customer/HomeHeader";
import AppFooter from "./customer/AppFooter";
import { motion } from "framer-motion";

const TermsAndConditions = () => {
  const access = localStorage.getItem("accessToken");

  return (
    <div className="flex flex-col min-h-screen">
      <div>{access ? <Header /> : <HomeHeader />}</div>

      {/* Animated Terms Content */}
      <motion.main
        className="flex-grow px-4 py-8 max-w-4xl mx-auto"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        <div className="bg-white shadow-xl rounded-2xl p-6 text-justify">
          <h1 className="text-2xl font-bold mb-6 text-center text-[#9061DB]">
            Welcome to Onzitr
          </h1>
          <p className="mb-4">
            Welcome to <strong>Onzitr</strong>. By accessing and using our
            website, you agree to comply with and be bound by the following
            terms and conditions. Please read these terms carefully before
            using our website.
          </p>
          <p className="mb-4">
            By accessing this website we assume you accept these terms and
            conditions. Do not continue to use our website if you do not agree
            to take all of the terms and conditions stated on this page.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            1. Use of Website
          </h2>
          <p className="mb-4">
            The content of this website is for general information and use. It
            is subject to change without notice.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            2. Intellectual Property
          </h2>
          <p className="mb-4">
            All content and materials on this website are owned by or licensed
            to us. Reproduction is prohibited other than in accordance with
            copyright notice.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            3. Privacy Policy
          </h2>
          <p className="mb-4">
            Your use of this website is also subject to our Privacy Policy,
            which outlines how we collect, use, and protect your personal
            information.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            4. Links to Third-Party Websites
          </h2>
          <p className="mb-4">
            This website may contain links to other websites. These links are
            provided for your convenience and do not signify endorsement of
            these websites. We have no responsibility for their content.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            5. Disclaimers
          </h2>
          <p className="mb-4">
            We shall not be liable for any damages arising out of or in
            connection with the use of this website. Your use of any information
            or materials on this website is at your own risk.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            6. Limitation of Liability
          </h2>
          <p className="mb-4">
            We shall not be liable for any damages arising out of or in
            connection with the use of this website. Your use of any information
            or materials on this website is at your own risk.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            7. Governing Law
          </h2>
          <p className="mb-4">
            Your use of this website and any dispute arising out of such use is
            subject to the laws of [Your Jurisdiction].
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            8. Changes to Terms and Conditions
          </h2>
          <p className="mb-4">
            We reserve the right to modify or replace these terms at any time.
            Continued use of the website signifies your acceptance of any
            changes.
          </p>

          <p className="mt-6">
            By using our website, you acknowledge that you have read,
            understood, and agree to these terms and conditions.
          </p>
        </div>
      </motion.main>

      <AppFooter />
    </div>
  );
};

export default TermsAndConditions;
